export default __webpack_public_path__ + "static/metadata-image-41781955a9db27fbc657ad57b06698ae.jpg";